import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHalfPipeMixingVessel = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 173,
	viewBox: "0 0 100.0 173.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 45,
			y: 0,
			width: 10,
			height: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 100,
			width: 10,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 115,
			width: 10,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 130,
			width: 10,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 90,
			y: 100,
			width: 10,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 90,
			y: 115,
			width: 10,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 90,
			y: 130,
			width: 10,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 75.36 159.14 L 81.14 167.3 L 89.3 161.53 L 83.53 153.36 Z M 57.18 163.98 L 58.98 173.82 L 68.82 172.02 L 67.02 162.18 Z M 16.27 152.65 L 10.15 160.57 L 18.07 166.68 L 24.18 158.77 Z M 32.39 161.92 L 29.92 171.61 L 39.61 174.08 L 42.08 164.39 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 10.0 50.0 A 40.0 15.0 0.0 1 1 90.0 50.0 L 90.0 140.0 A 40.0 25.0 0.0 1 1 10.0 140.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 43.0 3.0 L 57.0 3.0 M 43.0 17.0 L 57.0 17.0 M 50.0 20.0 L 50.0 150.5",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40,
			cy: 150,
			rx: 10,
			ry: 3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 60,
			cy: 150,
			rx: 10,
			ry: 3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgHalfPipeMixingVessel;
